import { required, helpers } from 'vuelidate/lib/validators'
const phoneformat = helpers.regex('phoneformat', /^([+])?(([-() ])*(\d+)*)*$/)

export default [{
  "id": "first-name",
  "type": "input",
  "label": "Imię",
  "size": 50,
  "model": "firstName",
  "validation": {
    required
  },
  "errorMsg": [
    "Wprowadź imię."
  ]
},
{
  "id": "last-name",
  "type": "input",
  "label": "Nazwisko",
  "size": 50,
  "model": "lastName",
  "validation": {
    required
  },
  "errorMsg": [
    "Wprowadź nazwisko."
  ]
},
{
  "id": "mobile1",
  "type": "input",
  "label": "Główny numer telefonu",
  "size": 50,
  "model": "mobile1",
  "validation": {
    required,
    phoneformat
  },
  "errorMsg": [
    "Wprowadź prawidłowy numer telefonu.",
    "Wprowadź prawidłowy numer telefonu."
  ]
},
{
  "id": "mobile2",
  "type": "input",
  "label": "Dodatkowy nr telefonu",
  "size": 50,
  "model": "mobile2",
  "validation": {
    phoneformat
  },
  "errorMsg": [
   "Wprowadź prawidłowy numer telefonu."
  ]
},
{
  "id": "address1",
  "type": "input",
  "label": "Adres wysyłki (linia 1)",
  "size": 100,
  "model": "address1",
  "validation": {
    required
  },
  "errorMsg": [
    "Wprowadź adres."
  ]
},
{
  "id": "address2",
  "type": "input",
  "label": "Adres wysyłki (linia 2)",
  "size": 100,
  "model": "address2"
},
{
  "id": "city",
  "type": "input",
  "label": "Miejscowość",
  "size": 50,
  "model": "city"
},
{
  "id": "state",
  "type": "input",
  "label": "Województwo / Powiat",
  "size": 50,
  "model": "state"
},
{
  "id": "postal-code",
  "type": "input",
  "label": "Kod pocztowy",
  "size": 50,
  "model": "postalCode",
  "validation": {
    required
  },
  "errorMsg": [
    "Wprowadź prawidłowy kod pocztowy."
  ]
},
{
  "id": "country",
  "type": "text",
  "label": "Kraj / Region",
  "size": 50,
  "model": "countryName"
}
]